import { useToast } from 'primevue/usetoast'
import { ApiError } from '../models/api-error.class'
import { ApiErrorType } from '@/modules/core/enums/api-error-type.ts'

export function useErrorHandler() {
  const toast = useToast()

  const handleError = (error: unknown) => {
    if (error instanceof ApiError) {
      toast.add({
        severity: getErrorSeverity(error.type),
        summary: getErrorTitle(error.type),
        detail: error.userMessage,
        life: error.type === ApiErrorType.OFFLINE_ERROR ? 10000 : 5000,
      })

      logError('Handled API Error:', error)
    } else {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An unexpected error occurred.',
        life: 5000,
      })
      logError('Unhandled error:', error)
    }
  }

  const getErrorSeverity = (
    type: ApiErrorType
  ): 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast' | undefined => {
    switch (type) {
      case ApiErrorType.OFFLINE_ERROR:
        return 'warn'
      case ApiErrorType.VALIDATION_ERROR:
        return 'warn'
      case ApiErrorType.AUTHENTICATION_ERROR:
      case ApiErrorType.AUTHORIZATION_ERROR:
        return 'error'
      default:
        return 'error'
    }
  }

  const getErrorTitle = (type: ApiErrorType): string => {
    switch (type) {
      case ApiErrorType.NETWORK_ERROR:
        return 'Connection Error'
      case ApiErrorType.OFFLINE_ERROR:
        return 'Offline Mode'
      case ApiErrorType.AUTHENTICATION_ERROR:
        return 'Authentication Required'
      case ApiErrorType.AUTHORIZATION_ERROR:
        return 'Access Denied'
      case ApiErrorType.VALIDATION_ERROR:
        return 'Invalid Input'
      case ApiErrorType.SERVER_ERROR:
        return 'Server Error'
      default:
        return 'Error'
    }
  }

  return { handleError }
}
